import {
    getSelectedObjectsProperty,
  } from './../utils/common';
  
  // Template for the Dropdown
  const multiSelectDropdownTemplate = `
  <div uib-dropdown class="filters-action">
    <style>  
    .pqeSilderDropdown {
      width: 451px !important;
      height: 70px !important;
      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    }
    .dropdown .bootstrapDropdown{
      overflow:unset;
    }
    </style>
      <button uib-dropdown-toggle id="{{data.buttonId}}" class="btn" type="button" data-tooltip-check="Filter by PQE">
        <svg version="1.1"  width="24" height="24" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          viewBox="0 0 614.9 540" style="enable-background:new 0 0 614.9 540;" xml:space="preserve">
            <style type="text/css">    
            .st0{fill:#9D9D9D;}
            .st1{clip-path:url(#SVGID_2_);fill:#848485;}
            .st2{clip-path:url(#SVGID_2_);fill:#B7333D;}          
              .st3{fill-rule:evenodd;clip-rule:evenodd;fill:#9D9D9D;}
              .st4{fill:#9D9D9D;}
            </style>
            <g>
              <path class="st3" d="M475.2,286.8c1.2-21.4,4.3-42.7,18-60.3c16.7-21.6,14.4-42.5-0.1-63.9c-11.9-17.6-17.9-37.3-18.6-58.4
                c-0.8-22.9-12.1-38.1-33.6-44.8c-19.6-6.1-34.7-17.6-46.4-33.7c-15.5-21.3-35.7-26-59.7-18.3c-16.8,5.4-33.5,4.6-50.5,1.1
                c-8.3-1.7-16.6-3.4-21.3-4.4c-16.8,0.1-28.6,4.6-35.7,15c-15.6,22.8-36.7,36.6-62.4,44.9c-15.8,5.1-24.4,16.6-23.3,33.1
                c1.7,27-7.3,50-22.6,71.5c-11,15.5-12.5,33-1.7,47.9c16.2,22.4,21.7,47.2,23.6,73.5c1.3,18,11.1,29.4,27.7,34.6
                c14.3,4.5,26.9,11.1,37.9,20c-19.7,39.7-59.9,102.1-76,137.8c-4.7,10.3-1.3,14.4,11.2,11.1c17-4.4,34.3-8.1,51.2-13.1
                c8.1-2.4,11.9-0.8,15.5,5.8c7.3,13.5,15.4,26.7,23.3,39.9c2.3,3.8,3.3,9.5,9.2,9.7c7.2,0.3,8-6.1,10-10.5
                c12-26.1,35.3-65.2,55.4-100.6c18,30.5,53.5,80.7,63.9,103.2c1.5,3.2,2.8,6.9,7.4,7.3c5.7,0.5,7.3-4,9.3-7.3
                c8.3-13.6,16.6-27.2,24.3-41.2c4.1-7.5,8.2-10.4,18-7.1c15,5.2,30.6,9,46.1,12.7c4.4,1.1,9.5,5.3,13.9,1.2
                c4.9-4.6,0.5-9.5-1.4-13.9c-14.5-32.6-59.3-97.9-78-134.8c10.7-7.8,22.7-13.7,35.7-18.5C464,319.9,474.1,307,475.2,286.8z
                  M164.1,199c0-78.8,66.1-144.3,144.9-143.7c79.1,0.6,143.9,66.6,143,145.6c-0.9,77.9-66.7,142.4-144.9,142
                C229.1,342.4,164,277,164.1,199z"/>
              <path class="st3" d="M424.1,199.6c0-63.4-51.4-114.8-114.8-114.8c-63.4,0-114.8,51.4-114.8,114.8c0,63.4,51.4,114.8,114.8,114.8
                C372.8,314.4,424.1,263,424.1,199.6z"/>
            </g>
        </svg>
       </button>
        <div uib-dropdown-menu class="bootstrapDropdown locationsDropdown pqeSilderDropdown pqe-slider-dropdown" >
            <div class="browse-opps-pqe-filter">
                <input ng-model="data.params.filterPQE.pqe" ng-change="data.function(data.params.filterPQE)" autocomplete="off" type="text" id="mySlider2" slider options="data.params.options"/>
            </div>
        </div>
    </div>
  `;
  
  // Controller for the dropdown directive
  const pqeSliderDropdownController = ($scope, $timeout, locationsService) => {
    const stopEventExecution = event => {
      event.stopPropagation();
    };
  
    $('.pqe-slider-dropdown').click(stopEventExecution);

    $scope.$on('ag-grid-reset-filters', function(evt){
      $scope.data.params.filterPQE.pqe = "-2;11";
      $scope.$apply()
    });
  
    $scope.selectItem = (item) => {
      item.ticked = !item.ticked;
      $scope.onChange();
    }
  
    // Resets the selection of all
  }
  
  // returns DDO for the dropdown
  const pqeSliderDropdown = () => {
    return {
      restrict: 'AE',
      scope: {
        data: '='
      },
      replace: true,
      template: multiSelectDropdownTemplate,
      controller: pqeSliderDropdownController
    };
  };
  
  angular
  .module('app.directives')
  .directive('pqeSliderDropdown', pqeSliderDropdown)


// WEBPACK FOOTER //
// ./scripts/shared/directives/pqe-slider-dropdown.js